import React from 'react';
import { func, bool, array, oneOfType, string, object, number } from 'prop-types';
import FlatTab from '../FlatTab/FlatTab';
import './ViewSwitcher.scss';
import classnames from 'classnames';

class ViewSwitcher extends React.Component {
  activeTab = 0;

  constructor(props) {
    super(props);
    this.setActiveTab = this.setActiveTab.bind(this);
  }

  static propTypes = {
    activeTab: number,
    tabList: oneOfType([array, object]),
    tabSwitch: func,
    isSticky: bool,
    className: string,
    isDisabled: bool,
    showIndicator: func,
    indicatorText: string
  };

  setActiveTab(e) {
    if (Object.prototype.hasOwnProperty.call(e.props, 'tabIndex') && !this.props.isDisabled) {
      this.props.tabSwitch(e.props.tabIndex);
    }
  }

  renderTabs() {
    const { tabList, activeTab, className, showIndicator, indicatorText } = this.props;
  
    return tabList.map((tab, idx) => {
      const classes = classnames('view-switcher__tab', `${className?.split(' ')[0]}-${idx}`, {
        'view-switcher__selected-tab': idx === activeTab,
        'view-switcher__unselected-tab': idx !== activeTab
      });
   
      return (
        <FlatTab
          key={idx}
          tabIndex={idx}
          className={classes}
          title={tab}
          tabClick={this.setActiveTab}
          selected={idx === activeTab}
          showIndicator={showIndicator}
          indicatorText={indicatorText}
          showImage={tab === 'AI Matching'}
        >
        </FlatTab>
      );

    });
  }

  render() {
    const { isSticky, className, isDisabled } = this.props;
    const classes = classnames('view-switcher', isSticky ? 'sticky-switch' : null, className, { disabled: isDisabled });
  
    return (
      <div className={classes}>
        {this.renderTabs()}
      </div>
    );
  }
}

export default ViewSwitcher;
